import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Funds } from './master-consulta-fundos.models';
const BASE_PATH = environment.basePath;
const BASE_PATH_External = environment.basePathExternal;

@Injectable({
  providedIn: 'root',
})
export class MasterConsultaFundosService {
  constructor(private _$http: HttpClient) {}

  getFunds() {
    return this._$http
      .get<any>(`${BASE_PATH_External}/fund/details`)
      .toPromise();
  }
}
